import React, { ReactNode } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface AccountContainerComponentProps {
    children: ReactNode;
    title: string;
}

export const AccountContainerComponent: React.FC<AccountContainerComponentProps> = ({ children, title }) => {
    const navigate = useNavigate();

    return (
        <Container>
            <Row className="vh-100 d-flex justify-content-center align-items-center">
                <Col md={8} lg={5} xs={12}>
                    <Card className="px-3 py-3 my-5">
                        <Card.Body>
                            <div className="mb-3 mt-md-4">
                                <h5
                                    className="fw-bold mb-3 text-center font-poppins cursor-pointer"
                                    translate="no"
                                    onClick={() => navigate('/home')}
                                >
                                    <span className="montacar-orange-text">monta</span>
                                    <span className="montacar-blue-text">car</span>
                                </h5>
                                <h4 className="mb-2 text-center">{title}</h4>
                                {children}
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};